export default "__VITE_ASSET__CU7cT1Wy__"